<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Online Anti Rangging Affidavits</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/online-anti-ragging-affidavites">Online Anti Rangging Affidavits</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="online-anti-ragging ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <p>As we know it is mandatory as per the Hon. Supreme Court &amp; UGC/AICTE Regulations that all students fill
          in an Anti Ragging Affidavit, each year. To make the process easy MHRD has developed an ON LINE Facility.</p>
        <h4 class="yellow-color">Affidavits can be filled ONLINE at :</h4>
        <a href="http://www.amanmovement.org" class="text-dark" target="_blank">1. http://www.amanmovement.org</a><br>
        <span class="text-dark" style="margin-left: 80px">OR</span><br>
        <a href="https://www.antiragging.in" class="text-dark" target="_blank">2. https://www.antiragging.in</a>
        <p>Students to fill their Affidavits on any of the two web sites. The procedure is very simple and explained on
          the web sites.</p>
      </div>
    </div>
  </div>
</section>
